module.exports = __webpack_public_path__ + "i18n/tr.3e4726d68cdbc3caaa1cf9d92f4b17f8.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/tr.json
// module id = 1065
// module chunks = 60